import { decodeHtmlEntities } from '@opallabs/lambda'
import { setAssetReferenceData } from './assetReference'

export const setLinksWithData = (linksWithDataJson) => ({
  assetReferences: linksWithDataJson.asset_references.map((asset) => ({
    ...setAssetReferenceData(asset),
  })),
  domain: decodeHtmlEntities(linksWithDataJson.domain),
  description: decodeHtmlEntities(linksWithDataJson.description),
  title: decodeHtmlEntities(linksWithDataJson.title),
  url: decodeHtmlEntities(linksWithDataJson.url),
})
